<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">MODELOS</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="modelos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir
                                v-if="$temAcessoView('ADMIN-MODELOS-01')"
                                @obterModelosAtualizados="obterModelos()"
                            ></btn-inserir>
                        </b-button-group>
                    </template>
                    <template slot="status" slot-scope="data">
                        <app-status
                            :status="data.ativo ? 'ATIVO' : 'INATIVO'"
                        ></app-status>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-download :modelo="data"></btn-download>
                        <btn-atualizar
                            :modelo="data"
                            v-if="$temAcessoView('ADMIN-MODELOS-01')"
                            @obterModelosAtualizados="obterModelos()"
                        ></btn-atualizar>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <!-- <router-view
            @obterTiposMovimentos="obterTiposMovimentos()"
        ></router-view> -->
    </div>
</template>

<script>
import ModelosServicos from './ModelosServicos'
import BtnInserir from './BtnInserir'
import BtnAtualizar from './BtnAtualizar'
import BtnDownload from './BtnDownload'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnDownload
    },

    props: {},

    data() {
        return {
            modelos: [],
            campos: [
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivo',
                    label: 'Arquivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'objeto',
                    label: 'Campos',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterModelos() {
            this.$store.dispatch('addRequest')
            ModelosServicos.obterModelos().then(response => {
                if (response) {
                    if (response.success) {
                        this.modelos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter modelos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }

        // detalhar(codMov) {
        //     this.$router.push({
        //         name: 'TiposMovimentos_Detalhar',
        //         params: {
        //             codMov: codMov
        //         }
        //     })
        // },

        // inserirTipoMovimento() {
        //     this.$router.push({
        //         name: 'TiposMovimentos_Inserir'
        //     })
        // }
    },

    created() {
        this.obterModelos()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Modelos'
        }
    },

    watch: {}
}
</script>
